const Home = () => {
  return (
    <div>
      <hr />
      <p>Login to continue a game.</p>
      <p>Sign up to begin.</p>
    </div>
  );
};

export default Home;
